import { createFileRoute } from "@tanstack/react-router";

import { TenantsPanel } from "../../../../workspaces/settings/platform/TenantsPanel";

export const Route = createFileRoute("/_console/settings/platform/organizations")({
  component: TenantsPanel,
});
